import { TApplicationState } from '../../types/redux';

export const selectErrorMessage = (state: TApplicationState) => {
  return state.form.errorMessage;
};
